import { Identifiable, Resource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function disableResource(httpClient: HttpClient, linker: Linker) {
  return (resource: Identifiable<Resource>, nextResource: Resource) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Resource>>>({
        endpoint: `/resources/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          deactivated: nextResource.deactivated,
        },
      })
      .then(linker.linkResource);
}

export { disableResource };
